import React from 'react';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import { colors } from '../../../styles/theme';

/** Estilos del CTA de login del MapHeader (`/#/app` invitado). */
export const mapHeaderLoginButtonStyle = {
  height: '44px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  padding: '0 14px',
  borderRadius: '8px',
  border: 'none',
  boxSizing: 'border-box',
  backgroundColor: colors.primary,
  color: '#ffffff',
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: 1,
  cursor: 'pointer',
  transition: 'background-color 0.15s ease',
  marginRight: '6px',
};

export const mapHeaderLoginButtonIconStyle = {
  fontSize: 20,
  width: 20,
  height: 20,
  display: 'block',
  flexShrink: 0,
};

const applyLoginButtonHover = (e, active) => {
  e.currentTarget.style.backgroundColor = active ? colors.primaryHover : colors.primary;
};

/**
 * Botón **Iniciar sesión** del header del mapa país. Reusado en vistas
 * compartidas para no divergir tipografía / alto / icono.
 */
export default function MapHeaderLoginButton({
  onClick,
  style = undefined,
  iconStyle = undefined,
  label = 'Iniciar sesión',
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{ ...mapHeaderLoginButtonStyle, ...style }}
      onMouseEnter={(e) => applyLoginButtonHover(e, true)}
      onMouseLeave={(e) => applyLoginButtonHover(e, false)}
      aria-label={label}
    >
      <AccountCircleOutlinedIcon style={{ ...mapHeaderLoginButtonIconStyle, ...iconStyle }} />
      <span>{label}</span>
    </button>
  );
}
